module.exports = __webpack_public_path__ + "img/danbaifen.44341d99.png";